/* global $, ScrollTrigger, gsap */

$(window).on('load', () => {
  $('body').removeClass('pre-animation');
  // This Handles the topper headline annimation
  const tlOnLoad = gsap.timeline({ delay: 0.5 });
  const onLoadTextCount = $('.anim-text-banner .header-section>.anim-text')
    .length;
  // console.log(onLoadTextCount);

  for (let i = 1; i <= onLoadTextCount; i++) {
    const onLoadTextWidth =
      '.anim-text-banner .header-section>.anim-text:nth-of-type(' + i + ')';
    tlOnLoad.to(
      onLoadTextWidth,
      {
        clip: 'rect(0px, ' + $(onLoadTextWidth).width() + 'px, 300px, 0px)',
        ease: 'expo.out',
        duration: 1,
      },
      '-=0.2',
    );
  }

  // ------------
  gsap.registerPlugin(ScrollTrigger);

  const tlMainAnim = gsap.timeline({ repeat: -1 });
  const animTextCount = $('.anim-text-parent>.anim-text').length;
  // const animImgCount = $('.topperImageWrapper>img').length;

  // This is where the image switcher is handled
  for (let i = 1; i <= animTextCount; i++) {
    const animTextWidth = '.anim-text-parent>.anim-text:nth-of-type(' + i + ')';
    const animImgWidth = '.topperImage>figure:nth-of-type(' + i + ')';

    tlMainAnim.to(animTextWidth, { opacity: 1, duration: 0.1 });
    tlMainAnim.to(animTextWidth, {
      clip: 'rect(0px, ' + $(animTextWidth).width() + 'px, 300px, 0px)',
      ease: 'expo.out',
      duration: 1.0,
    });
    tlMainAnim.to(animImgWidth, {
      zIndex: 2,
    });
    tlMainAnim.to(
      animTextWidth,
      { clip: 'rect(0px, 0px, 300px, 0px)', ease: 'expo.out', duration: 1.5 },
      '+=0.75',
    );
    tlMainAnim.to(animTextWidth, { opacity: 0, duration: 0.1 });
  }

  tlOnLoad.add(tlMainAnim, '-=0.5');
  gsap.fromTo(
    '.topper .topperImage',
    {
      scale: 0.5,
      opacity: 0,
    },
    {
      delay: 2.8,
      scale: 1,
      opacity: 1,
      duration: 0.5,
      // yPercent: -30,
      scrollTrigger: {
        trigger: '.topper',
      },
    },
  );

  gsap.to('.topper .topperImage', {
    yPercent: -23,
    ease: 'none',
    scrollTrigger: {
      trigger: '.topper',
      // start: 'top bottom', // the default values
      // end: 'bottom top',
      scrub: 1,
    },
  });
});

// gsap.fromTo('.topper .topperImageWrapper', {
//   scale: 0.5,
//   opacity: 0,
// }, {
//   delay: 4,
//   scale: 1,
//   opacity: 1,
//   duration: 0.5,
//   // yPercent: -30,
//   scrollTrigger: {
//     trigger: '.topper',
//   },
// });

// CTA form
gsap.from('.home-cta .form', {
  yPercent: 30,
  ease: 'none',
  scrollTrigger: {
    trigger: '.home-cta',
    // start: 'top bottom', // the default values
    // end: 'bottom top',
    scrub: 1,
  },
});
// Gallery images
gsap.to('.galleryFirstImage', {
  yPercent: -120,
  ease: 'none',
  scrollTrigger: {
    trigger: '.home-gallery',
    // start: 'top bottom', // the default values
    // end: 'bottom top',
    scrub: 1,
  },
});

gsap.from('.galleryMiddleImage', {
  yPercent: -20,
  ease: 'none',
  scrollTrigger: {
    trigger: '.home-gallery',
    // start: 'top bottom', // the default values
    // end: 'bottom top',
    scrub: 1,
  },
});
// Stories
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if (isIE11) {
  $('.panel').addClass('active');
} else {
  let panels = document.querySelectorAll('.panel');
  panels = Array.from(panels);
  panels.forEach((section) => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top+=100px bottom',
      end: 'bottom 90%',
      // markers: true,
      onEnter: () => {
        $(section).addClass('active');
      },
    });
  });
}
ScrollTrigger.matchMedia({
  '(min-width: 768px)': () => {
    gsap.utils
      .toArray('.parallax-container .parallax-content')
      .forEach((section) => {
        gsap.fromTo(
          section,
          {
            y: `${-section.offsetHeight / 2}px`,
          },
          {
            scrollTrigger: {
              trigger: section.parentElement,
              scrub: true,
            },
            y: `${section.offsetHeight / 2}px`,
            ease: 'none',
          },
        );
      });
  },
});
// Value Statement
ScrollTrigger.create({
  trigger: '.home-value-statement',
  start: 'top 50%',
  onEnter: () => {
    const tlLargeText = gsap.timeline({ delay: 0.5 });
    const onLargeTextCount = $('.home-value-statement h2> span').length;
    // console.log(onLoadTextCount);

    for (let i = 1; i <= onLargeTextCount; i++) {
      const largeTextWidth =
        '.home-value-statement h2> span:nth-of-type(' + i + ')';
      tlLargeText.to(
        largeTextWidth,
        {
          clip: 'rect(0px, ' + $(largeTextWidth).width() + 'px, 300px, 0px)',
          ease: 'expo.out',
          duration: 1,
        },
        '-=0.2',
      );
    }
    tlLargeText.add();
  },
});
// Image and copy
gsap.fromTo(
  '.imageAndCopy figure',
  {
    scale: 0.5,
    opacity: 0,
  },
  {
    delay: 1,
    scale: 1,
    opacity: 1,
    duration: 0.5,
    scrollTrigger: {
      trigger: '.home-value-statement',
    },
  },
);

gsap.to('.imageAndCopy .statementImage', {
  yPercent: -10,
  ease: 'none',
  scrollTrigger: {
    trigger: '.home-value-statement',
    // start: 'top bottom', // the default values
    // end: 'bottom top',
    scrub: 1,
  },
});
// Stat section
// gsap.from('.stat-wrapper .stat-content', {
//   yPercent: 100,
//   duration: 1,
//   ease: 'expo.out',
//   stagger: 0.18,
//   scrollTrigger: {
//     trigger: '.home-stats',
//     start: 'top 40%',
//   },
// });

// gsap.from('.stat-wrapper .stat-content > *', {
//   opacity: 0,
//   yPercent: -100,
//   duration: 1,
//   ease: 'expo.out',
//   stagger: 0.18,
//   scrollTrigger: {
//     trigger: '.home-stats',
//     start: 'top 40%',
//   },
// });

ScrollTrigger.matchMedia({
  '(min-width: 768px)': () => {
    gsap.from('.home-stats .stat-wrapper:nth-child(1n)', {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
        trigger: '.home-stats',
        // start: 'top bottom', // the default values
        // end: 'bottom top',
        scrub: 1,
      },
    });

    gsap.from('.home-stats .stat-wrapper:nth-child(2n)', {
      yPercent: -20,
      ease: 'none',
      scrollTrigger: {
        trigger: '.home-stats',
        // start: 'top bottom', // the default values
        // end: 'bottom top',
        scrub: 1,
      },
    });
  },
});
// Statement Section
ScrollTrigger.create({
  trigger: '.home-statement-work',
  start: 'top 134px',
  onEnter: () => {
    const tlText = gsap.timeline();
    const onLargeTextCount = $('.home-statement-work .missionContent p >span')
      .length;
    // console.log(onLoadTextCount);

    for (let i = 1; i <= onLargeTextCount; i++) {
      const textWidth =
        '.home-statement-work .missionContent p >span:nth-of-type(' + i + ')';
      tlText.to(
        textWidth,
        {
          clip: 'rect(0px, ' + $(textWidth).width() + 'px, 360px, 0px)',
          ease: 'expo.out',
          duration: 0.5,
        },
        '-=0.2',
      );
    }
    // tlLargeText.add();
  },
});

ScrollTrigger.create({
  trigger: '#point-1',
  start: 'top 65%',
  // markers: true,
  className: 'active',
  onEnter: () => {
    const tlText = gsap.timeline();
    const onLargeTextCount = $('#point-1 h2 > span').length;
    // console.log(onLoadTextCount);

    for (let i = 1; i <= onLargeTextCount; i++) {
      const textWidth = '#point-1 h2 > span:nth-of-type(' + i + ')';
      tlText.to(
        textWidth,
        {
          clip: 'rect(0px, ' + $(textWidth).width() + 'px, 300px, 0px)',
          ease: 'expo.out',
          duration: 1,
        },
        '-=0.2',
      );
    }
  },
});

gsap.fromTo(
  '#point-1 .rightContent *',
  {
    yPercent: -100,
    opacity: 0,
    stagger: 0.18,
  },
  {
    delay: 1,
    yPercent: 0,
    opacity: 1,
    stagger: 0.18,
    ease: 'expo.out',
    scrollTrigger: {
      trigger: '#point-1',
      start: 'top 65%',
    },
  },
);

ScrollTrigger.create({
  trigger: '#point-2',
  start: 'top 65%',
  // markers: true,
  className: 'active',
  onEnter: () => {
    const tlText = gsap.timeline();
    const onLargeTextCount = $('#point-2 h2 > span').length;
    // console.log(onLoadTextCount);

    for (let i = 1; i <= onLargeTextCount; i++) {
      const textWidth = '#point-2 h2 > span:nth-of-type(' + i + ')';
      tlText.to(
        textWidth,
        {
          clip: 'rect(0px, ' + $(textWidth).width() + 'px, 300px, 0px)',
          ease: 'expo.out',
          duration: 1,
        },
        '-=0.2',
      );
    }
  },
});

gsap.fromTo(
  '#point-2 .rightContent *',
  {
    yPercent: -100,
    opacity: 0,
    stagger: 0.18,
  },
  {
    delay: 1,
    yPercent: 0,
    opacity: 1,
    stagger: 0.18,
    ease: 'expo.out',
    scrollTrigger: {
      trigger: '#point-2',
    },
  },
);

ScrollTrigger.create({
  trigger: '#point-3',
  start: 'top 65%',
  // markers: true,
  className: 'active',
  onEnter: () => {
    const tlText = gsap.timeline();
    const onLargeTextCount = $('#point-3 h2 > span').length;
    // console.log(onLoadTextCount);

    for (let i = 1; i <= onLargeTextCount; i++) {
      const textWidth = '#point-3 h2 > span:nth-of-type(' + i + ')';
      tlText.to(
        textWidth,
        {
          clip: 'rect(0px, ' + $(textWidth).width() + 'px, 300px, 0px)',
          ease: 'expo.out',
          duration: 1,
        },
        '-=0.2',
      );
    }
  },
});

gsap.fromTo(
  '#point-3 .rightContent *',
  {
    yPercent: -100,
    opacity: 0,
    stagger: 0.18,
  },
  {
    delay: 1,
    yPercent: 0,
    opacity: 1,
    stagger: 0.18,
    ease: 'expo.out',
    scrollTrigger: {
      trigger: '#point-3',
    },
  },
);
